// extracted by mini-css-extract-plugin
export default {"shortcuts":"pages_shortcuts__b5KM8"};